// Full country list for the inquiry form: display name, ISO 3166-1 alpha-2 code,
// and international dialing code. Used for the Country dropdown and the phone
// country-code selector.
export const ALL_COUNTRIES = [
    { name: "Afghanistan", iso: "af", dial: "+93" },
    { name: "Albania", iso: "al", dial: "+355" },
    { name: "Algeria", iso: "dz", dial: "+213" },
    { name: "Andorra", iso: "ad", dial: "+376" },
    { name: "Angola", iso: "ao", dial: "+244" },
    { name: "Argentina", iso: "ar", dial: "+54" },
    { name: "Armenia", iso: "am", dial: "+374" },
    { name: "Australia", iso: "au", dial: "+61" },
    { name: "Austria", iso: "at", dial: "+43" },
    { name: "Azerbaijan", iso: "az", dial: "+994" },
    { name: "Bahrain", iso: "bh", dial: "+973" },
    { name: "Bangladesh", iso: "bd", dial: "+880" },
    { name: "Belarus", iso: "by", dial: "+375" },
    { name: "Belgium", iso: "be", dial: "+32" },
    { name: "Belize", iso: "bz", dial: "+501" },
    { name: "Benin", iso: "bj", dial: "+229" },
    { name: "Bhutan", iso: "bt", dial: "+975" },
    { name: "Bolivia", iso: "bo", dial: "+591" },
    { name: "Bosnia and Herzegovina", iso: "ba", dial: "+387" },
    { name: "Botswana", iso: "bw", dial: "+267" },
    { name: "Brazil", iso: "br", dial: "+55" },
    { name: "Brunei", iso: "bn", dial: "+673" },
    { name: "Bulgaria", iso: "bg", dial: "+359" },
    { name: "Burkina Faso", iso: "bf", dial: "+226" },
    { name: "Cambodia", iso: "kh", dial: "+855" },
    { name: "Cameroon", iso: "cm", dial: "+237" },
    { name: "Canada", iso: "ca", dial: "+1" },
    { name: "Chile", iso: "cl", dial: "+56" },
    { name: "China", iso: "cn", dial: "+86" },
    { name: "Colombia", iso: "co", dial: "+57" },
    { name: "Costa Rica", iso: "cr", dial: "+506" },
    { name: "Croatia", iso: "hr", dial: "+385" },
    { name: "Cyprus", iso: "cy", dial: "+357" },
    { name: "Czechia", iso: "cz", dial: "+420" },
    { name: "Denmark", iso: "dk", dial: "+45" },
    { name: "Dominican Republic", iso: "do", dial: "+1" },
    { name: "Ecuador", iso: "ec", dial: "+593" },
    { name: "Egypt", iso: "eg", dial: "+20" },
    { name: "El Salvador", iso: "sv", dial: "+503" },
    { name: "Estonia", iso: "ee", dial: "+372" },
    { name: "Ethiopia", iso: "et", dial: "+251" },
    { name: "Finland", iso: "fi", dial: "+358" },
    { name: "France", iso: "fr", dial: "+33" },
    { name: "Georgia", iso: "ge", dial: "+995" },
    { name: "Germany", iso: "de", dial: "+49" },
    { name: "Ghana", iso: "gh", dial: "+233" },
    { name: "Greece", iso: "gr", dial: "+30" },
    { name: "Guatemala", iso: "gt", dial: "+502" },
    { name: "Honduras", iso: "hn", dial: "+504" },
    { name: "Hong Kong", iso: "hk", dial: "+852" },
    { name: "Hungary", iso: "hu", dial: "+36" },
    { name: "Iceland", iso: "is", dial: "+354" },
    { name: "India", iso: "in", dial: "+91" },
    { name: "Indonesia", iso: "id", dial: "+62" },
    { name: "Iran", iso: "ir", dial: "+98" },
    { name: "Iraq", iso: "iq", dial: "+964" },
    { name: "Ireland", iso: "ie", dial: "+353" },
    { name: "Israel", iso: "il", dial: "+972" },
    { name: "Italy", iso: "it", dial: "+39" },
    { name: "Ivory Coast", iso: "ci", dial: "+225" },
    { name: "Jamaica", iso: "jm", dial: "+1" },
    { name: "Japan", iso: "jp", dial: "+81" },
    { name: "Jordan", iso: "jo", dial: "+962" },
    { name: "Kazakhstan", iso: "kz", dial: "+7" },
    { name: "Kenya", iso: "ke", dial: "+254" },
    { name: "Kuwait", iso: "kw", dial: "+965" },
    { name: "Kyrgyzstan", iso: "kg", dial: "+996" },
    { name: "Laos", iso: "la", dial: "+856" },
    { name: "Latvia", iso: "lv", dial: "+371" },
    { name: "Lebanon", iso: "lb", dial: "+961" },
    { name: "Libya", iso: "ly", dial: "+218" },
    { name: "Lithuania", iso: "lt", dial: "+370" },
    { name: "Luxembourg", iso: "lu", dial: "+352" },
    { name: "Macau", iso: "mo", dial: "+853" },
    { name: "Madagascar", iso: "mg", dial: "+261" },
    { name: "Malaysia", iso: "my", dial: "+60" },
    { name: "Maldives", iso: "mv", dial: "+960" },
    { name: "Malta", iso: "mt", dial: "+356" },
    { name: "Mauritius", iso: "mu", dial: "+230" },
    { name: "Mexico", iso: "mx", dial: "+52" },
    { name: "Moldova", iso: "md", dial: "+373" },
    { name: "Monaco", iso: "mc", dial: "+377" },
    { name: "Mongolia", iso: "mn", dial: "+976" },
    { name: "Montenegro", iso: "me", dial: "+382" },
    { name: "Morocco", iso: "ma", dial: "+212" },
    { name: "Mozambique", iso: "mz", dial: "+258" },
    { name: "Myanmar", iso: "mm", dial: "+95" },
    { name: "Nepal", iso: "np", dial: "+977" },
    { name: "Netherlands", iso: "nl", dial: "+31" },
    { name: "New Zealand", iso: "nz", dial: "+64" },
    { name: "Nigeria", iso: "ng", dial: "+234" },
    { name: "North Macedonia", iso: "mk", dial: "+389" },
    { name: "Norway", iso: "no", dial: "+47" },
    { name: "Oman", iso: "om", dial: "+968" },
    { name: "Pakistan", iso: "pk", dial: "+92" },
    { name: "Panama", iso: "pa", dial: "+507" },
    { name: "Paraguay", iso: "py", dial: "+595" },
    { name: "Peru", iso: "pe", dial: "+51" },
    { name: "Philippines", iso: "ph", dial: "+63" },
    { name: "Poland", iso: "pl", dial: "+48" },
    { name: "Portugal", iso: "pt", dial: "+351" },
    { name: "Qatar", iso: "qa", dial: "+974" },
    { name: "Romania", iso: "ro", dial: "+40" },
    { name: "Russia", iso: "ru", dial: "+7" },
    { name: "Rwanda", iso: "rw", dial: "+250" },
    { name: "Saudi Arabia", iso: "sa", dial: "+966" },
    { name: "Senegal", iso: "sn", dial: "+221" },
    { name: "Serbia", iso: "rs", dial: "+381" },
    { name: "Singapore", iso: "sg", dial: "+65" },
    { name: "Slovakia", iso: "sk", dial: "+421" },
    { name: "Slovenia", iso: "si", dial: "+386" },
    { name: "South Africa", iso: "za", dial: "+27" },
    { name: "South Korea", iso: "kr", dial: "+82" },
    { name: "Spain", iso: "es", dial: "+34" },
    { name: "Sri Lanka", iso: "lk", dial: "+94" },
    { name: "Sweden", iso: "se", dial: "+46" },
    { name: "Switzerland", iso: "ch", dial: "+41" },
    { name: "Taiwan", iso: "tw", dial: "+886" },
    { name: "Tanzania", iso: "tz", dial: "+255" },
    { name: "Thailand", iso: "th", dial: "+66" },
    { name: "Tunisia", iso: "tn", dial: "+216" },
    { name: "Turkey", iso: "tr", dial: "+90" },
    { name: "Turkmenistan", iso: "tm", dial: "+993" },
    { name: "Uganda", iso: "ug", dial: "+256" },
    { name: "Ukraine", iso: "ua", dial: "+380" },
    { name: "United Arab Emirates", iso: "ae", dial: "+971" },
    { name: "United Kingdom", iso: "gb", dial: "+44" },
    { name: "United States", iso: "us", dial: "+1" },
    { name: "Uruguay", iso: "uy", dial: "+598" },
    { name: "Uzbekistan", iso: "uz", dial: "+998" },
    { name: "Venezuela", iso: "ve", dial: "+58" },
    { name: "Vietnam", iso: "vn", dial: "+84" },
    { name: "Yemen", iso: "ye", dial: "+967" },
    { name: "Zambia", iso: "zm", dial: "+260" },
    { name: "Zimbabwe", iso: "zw", dial: "+263" },
];

// Unique dial codes (with a representative country label) for the phone selector.
export const DIAL_CODES = (() => {
    const seen = new Set();
    return ALL_COUNTRIES.filter((c) => {
        if (seen.has(c.dial)) return false;
        seen.add(c.dial);
        return true;
    })
        .map((c) => ({ dial: c.dial, name: c.name, iso: c.iso }))
        .sort((a, b) => Number(a.dial.slice(1)) - Number(b.dial.slice(1)));
})();
